<template>
  <div class="pieChart" id="pieChart"></div>
</template>
<script>
/**
 * @file:  View 组件 echart
 * @author: v_chengmengya
 * @date: 2019-05-15
 * @description: UI组件
 */
import echarts from 'echarts'
import {getBaseGasStationArray} from '@/utils/dictionary'
export default {
  props: {
    subtext: {
      default: '',
      type: String
    },
    pieData: {
      default: () => {
        return []
      },
      type: Array
    }
  },
  watch: {
    subtext: function() {
      this.initChart()
    }
  },
  methods: {
    initChart() {
      let data=getBaseGasStationArray();
      let that = this
      let city = echarts.init(document.getElementById('pieChart'))
      let option = {
        title: {
          text: '各品牌加油站停靠次数分布',
          subtext: that.subtext,
          textAlign: 'left'
        },
        legend: {
          // 图例
          type: 'plain',
          orient: 'vertical',
          top: 55,
          left: 0,
          right: 0,
          //data: ['中国石化', '中国石油', '其他油站'],
          data
        },
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        color: ['#FF7B50', '#37A2D9', '#32E1E6'],
        series: [
          {
            name: '名称',
            type: 'pie',
            radius: '70%',
            center: ['40%', '60%'],
            data: that.pieData,
            label: {
              normal: {
                show: true,
                position: 'inside',
                textStyle: {
                  color: '#fff',
                  fontSize: 14
                },
                formatter: '{c}\n{d}%',
                align: 'left'
              }
            }
          }
        ]
      }
      city.setOption(option)
    }
  },
  mounted() {
    this.initChart()
  }
}
</script>
